import $ from "jquery";

const teamsTitle = $(".teams-group .title");
const teamsCards = $(".teams-group .cards");

teamsTitle.on("click", function () {
  teamsCards.slideUp();
  teamsTitle.removeClass("opened");
  let clickedItem = $(this).siblings(".cards");

  if (clickedItem.is(":visible")) {
    $(this).removeClass("opened");
    clickedItem.slideUp();
  } else {
    $(this).addClass("opened");
    clickedItem.slideDown();
  }
});

